export default {"src":"/app/membership/_next/static/media/left-quote.27cbf47a.svg","height":23,"width":26,"blurWidth":0,"blurHeight":0};